module.exports = __webpack_public_path__ + "img/storm-red.4d2c7fe3.svg";